import { render, staticRenderFns } from "./FarmHarvestsTable.vue?vue&type=template&id=3db29438&lang=html&"
import script from "./FarmHarvestsTable.vue?vue&type=script&lang=js&"
export * from "./FarmHarvestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports